import React, {FC, useEffect, useMemo, useState} from "react";
import {
  Container,
  WrapperRow,
  Title,
  HideWrapper,
  BlueText,
  LeftSide,
  BodyText,
  BodyLink,
  QuotasContainer,
  StateWrapper,
  GreenDot,
  Greentext
} from '../Instances/styles'
import { Diagrams } from "../../HomePage/components";
import { useTranslation } from "react-i18next";
import { icons } from "../../../icons";
import StyledIcon from "../../../components/styled-icon";
import { Button, ModalVariables, StartPage, Table, TutorialVodeo, SearchComponent, FilterBar } from "../../../components";
import TutorImg from './illustration.svg'
import TutorDarkImg from './illustration-dark.svg'
import { useTheme } from "styled-components";
import { useNavigate } from "react-router";
import { useUi } from "../../../context/ui.context";
import { useAuth } from "../../../context/user.context";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import { compareArrays } from "../../../utils/findIntersection";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import rootConfig from "../../../config";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { portService } from "../../../api";
import { handleStatusName } from "../../../utils/handle-status-name";
import useUpdateEffect from "../../../hooks/useUpdateEffect";

const PORT_FILTER_KEYS = [
  'created_at',
  'project__service__client',
  'network',
  'network__region',
  'status',
  'admin_state_up',
  'port_security_enabled',
];
const DEFAULT_ORDERING = '-created_at';

const Ports:FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const theme:any = useTheme()
  const {viewAlert} = useUi()
  const {user, quotas} = useAuth()
  const {setDataToLs} = useLocalStorage()

  const [ports, setPorts] = useState<any[]>([])
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [filtering, setFiltering] = useQueryParam('filtering', StringParam);
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [paginationData, setPaginationData] = useState<any>()
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [selectedPort, setSelectedPort] = useState<any>()
  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [checked, setChecked] = useState<any[]>([])
  const [filterOptions, setFilterOptions] = useState<any>()
  const normalizedFilterOptions = useMemo(() => {
    if (!filterOptions) return undefined;
    const base: Record<string, any> = {};
    PORT_FILTER_KEYS.forEach((key) => {
      if (Array.isArray(filterOptions?.[key]) && filterOptions?.[key]?.length) {
        base[key] = filterOptions[key];
      }
    });
    // Fallback for boolean filters
    const booleanOptions = [
      { display: t("YES"), value: 'true' },
      { display: t("NO"), value: 'false' },
    ];
    ['admin_state_up', 'port_security_enabled'].forEach((key) => {
      if (!base[key]) {
        base[key] = booleanOptions;
      }
    });
    return base;
  }, [filterOptions, t]);
  const handleResetFilters = () => {
    setSearchString(undefined);
    setFiltering(undefined);
    setOrdering(DEFAULT_ORDERING);
    setPage(1);
    setAllChecked(false);
    setChecked([]);
  }
  const editChecked = (id:any, isAll?:boolean) => {
    if(id === null) {
      setChecked([])
      setAllChecked(false)
      return
    }
    const founded = checked.find((item:any) => item.id === id?.id)
    if(founded) {
      if(isAll){ 
        return 
      } else {
        setChecked((prev:any) => {
          return prev.filter((item:any) => item.id !== id?.id)
        })
        setAllChecked(false)
      }
    } else {
      setChecked((prev) => [...prev, id])
    }
  } 
  useEffect(() => {
    if(compareArrays(ports, checked) && checked?.length !== 0){
      setAllChecked(true)
    }
  },[checked])
  useUpdateEffect(() => {
    setPage(1)
  }, [pageSize, filtering])
  useEffect(() => {
    if (!ordering) {
      setOrdering(DEFAULT_ORDERING);
    }
  }, [ordering, setOrdering]);
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const _updatePorts = () => {
    // setLoading(true)
    portService.getPorts({
      page:page || 1,
      page_size:pageSize || 10,
      ordering:ordering || DEFAULT_ORDERING,
      search:searchString||'',
      filtering: filtering || '',
    })
    .then((res) => {
      setFilterOptions(res?.data?.filter_options);
      setPorts(res.data.objects.map((port:any) => {
        return {
          ...port,
          navigate: port.id,
          network: port.network?.name,
          fixed_ips:(
            <>
              {port?.fixed_ips?.map((ip:any) => (
                <>
                  {ip?.ip_address || ip?.subnet_id}
                </>
              ))}
            </>
          ),
          name: port.name || port.id,
          admin_state:port?.admin_state_up ? `${t("YES")}` : `${t("NO")}`,
          created_at:timeConverterMMDDYYHHMM(port.created_at),
          status:(
            <StateWrapper>
              <GreenDot active={port.status}/>
              <Greentext active={port.status}>
                {handleStatusName(port.status,t)}
              </Greentext>
            </StateWrapper>),
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail || `${t("ERROR_OCCURRED")}`,
      })
      navigate('/home')
      setPageLoading(false)
    })
  }
  useEffect(() => {
    _updatePorts()
    const interval = setInterval(() => {
      _updatePorts()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString,
    filtering])
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }

  const items = [
    {
      title:t("EDIT"),
      id:'3',
      icon:icons.Edit,
      onClick: (port:any) => {
        navigate(`${port.id}/edit`)
      },
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(port:any) => {
        openModal('delete')
        setAlertTitle(t("PORT"))
        setAlertSubTitle([port])
        setSelectedPort(port)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]

  const Columns = [
    {
      title:t("NAME"),
      key:'name',
      sorted:true,
    },
    {
      title:t("STATUS"),
      key:'status'
    },
    {
      title:t("NETWORK"),
      key:'network',
      sorted:true,
    },
    {
      title:t("FIXED_IPS"),
      key:'fixed_ips'
    },
    {
      title:t("MAC_ADDRESS"),
      key:'mac_address'
    },
    {
      title:t("DEVICE_OWNER"),
      key:'device_owner'
    },

    {
      title:t("ADMIN_STATE"),
      key:'admin_state'
    },
    {
      title:t("CREATED_AT"),
      key:'created_at',
      sorted:true,
    },
    {
      title:'',
      key:'props'
    },
  ]

  const closeModal = async () => {
    setLoading(true)
    try{
      if(allChecked) {
        let promises:any[] = []
        await ports.map((item:any) => {
          let promise = portService.deletePort(item.id)
          promises.push(promise)
        })
        await Promise.all(promises)
        await _updatePorts()
        await setAllChecked(false)
      } else if (checked?.length > 0){
        let promises:any[] = []
        await checked.map((item:any) => {
          let promise = portService.deletePort(item.id)
          promises.push(promise)
        })
        await Promise.all(promises)
        await _updatePorts()
        await setChecked([])
      } else if (selectedPort) {
        await portService.deletePort(selectedPort.id)
        await _updatePorts()
      }
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
      _updatePorts()
      setPageLoading(false)
      setLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
      setLoading(false)
    }
  }


  const _createFunc = () => {
    navigate('create')
  }
  return (
    <>
      <StartPage
        title={`${t("PORTS")}`}
        noResourceText={`${t("NO_PORTS")}`}
        createResourceButton={`${t('CREATE_PORT')}`}
        createResourceButtonEventOrLink={_createFunc}
        haveResource={ports.length > 0}
        learnMoreAboutResource={`${t('LEARN_MORE_PORTS')}`}
        howCreateVideoText={`${t('HOW_CREATE_PORT')}`}
        learnMoreAboutResourceLink={`${rootConfig.docs_url}category/ports`}
        withoutCreateResourceButton
        rightCustomCreateButton={
          <div style={{display:'flex', flexDirection:'column', gap:'10px', width:'100%'}}>
            <div style={{display:'flex', alignItems:'center', gap:'12px', width:'100%'}}>
              <Button
                title={t('CREATE_PORT')}
                onClick={_createFunc}
                variant='primary'
                size='custom'
                customStyles={{height:'40px', whiteSpace:'nowrap'}}
              />
              <div style={{flex:1, minWidth:'200px'}}>
                <SearchComponent />
              </div>
              <div style={{display:'flex', alignItems:'center', gap:'8px', marginLeft:'auto'}}>
                <Button
                  onClick={() => {
                    setAlertTitle(t("PORTS"))
                    setAlertSubTitle(allChecked ? ports : checked)
                    openModal('delete')
                  }}
                  variant='icon'
                  size='display'
                  test_id='button-delete'
                  disabled={!allChecked && checked?.length === 0 }
                >
                  <img src={icons.DeleteIcon}/>
                </Button>
                <Button
                  title={t("CLEAR_FILTERS")}
                  onClick={handleResetFilters}
                  variant='stroke'
                  size='display'
                  disabled={
                    (!filtering || filtering === '') &&
                    !searchString &&
                    ordering === DEFAULT_ORDERING
                  }
                />
              </div>
            </div>
            {normalizedFilterOptions ? (
              <FilterBar filterOptions={normalizedFilterOptions} />
            ) : null}
          </div>
        }
        videoImage={TutorImg}
        videoImageDark={TutorDarkImg}
        pageLoading={pageLoading}
        tableData={{
          columns:Columns,
          data:ports,
          props:items,
          allChecked:allChecked,
          setAllChecked:setAllChecked,
          checked:checked,
          setChecked:editChecked,
          paginationData:paginationData,
          updateData:_updatePorts
        }}
      />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
        instance={selectedPort}
      />
    </>
  )
}


export default Ports
